import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useHotelSearchLogic } from './hooks/useHotelSearchLogic';

import HotelSearchSkeleton from './HotelSearchSkeleton';
import HotelSearchHeader from './components/HotelSearchHeader';
import HotelFiltersDialog from './components/HotelFiltersDialog';
import HotelsResultsContainer from './components/HotelsResultsContainer';
import { ScrollOnMount } from '@shared/components/ScrollOnMount';

import { useGoogleMaps } from '@shared/providers/GoogleMapsProvider';

const HotelSearchResults = ({
  hotelSearchResults,
  total_passengers,
  totalNights,
  citySelected,
  hasFastResults,
  hasFinalResults,
  getFavConfig,
  isLoadingResults,
  hotReferenceCities,
  searchInfo,
}) => {
  const {
    aboutSection,
    fullScreen,
    isMobile,
    viewFullWidhtMap,
    hotelsWithPagination,
    allFilteredHotels,
    handleCardMouseEnter,
    handleCardMouseLeave,
    handleClose,
    handleClickOpen,
    handleMapFullWidth,
    handleModal,
    handleCloseModal,
    handleChangePage,
    handleSetOrderHotelsBy,
    handelFilterAplicated,
    setActualPage,
    setNameFilter,
    setPriceRange,
    setPricesFiltered,
    setFilter,
    setIsLoadImage,
    nameFilter,
    quantityFiltered,
    priceRange,
    pricesFiltered,
    filter,
    orderHotelsBy,
    pageQuantity,
    actualPage,
    mapCenter,
    open,
    showModal,
    hotel,
    hoveredHotel,
    id_site,
    business_types,
    tokenMap,
    sites,
    total_passengers: tp,
    totalNights: tn,
    isLoadImage,
    handleClearFilterAplicated,
  } = useHotelSearchLogic({
    hotelSearchResults,
    totalNights,
    total_passengers,
  });

  const [showProgress, setShowProgress] = useState(false);

  const { isLoaded, loadError } = useGoogleMaps();

  if (!hasFastResults && !hasFinalResults) {
    return (
      <HotelSearchSkeleton
        isLoading
        isMobile={isMobile}
        viewFullWidhtMap={viewFullWidhtMap}
      />
    );
  }

  if (!isLoaded) {
    // Mientras carga la API de Google
    return (
      <HotelSearchSkeleton
        isLoading
        isMobile={isMobile}
        viewFullWidhtMap={viewFullWidhtMap}
      />
    );
  }

  if (loadError) {
    return <div>Error al cargar Google Maps</div>;
  }

  return (
    <Grid
      container
      id="GRIDROOTPADRE"
      direction="column"
      ref={aboutSection}
      sx={{
        backgroundColor: '#F6F6F6',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        px: { xs: '16px', md: '32px', lg: '58px' },
      }}
    >
      <ScrollOnMount />
      <HotelFiltersDialog
        fullScreen={fullScreen}
        open={open}
        handleClose={handleClose}
        hotelSearchResults={hotelSearchResults}
        setFilter={setFilter}
        handelFilterAplicated={handelFilterAplicated}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        pricesFiltered={pricesFiltered}
        setPricesFiltered={setPricesFiltered}
        filter={filter}
        totalNights={tn}
        orderHotelsBy={orderHotelsBy}
        handleSetOrderHotelsBy={handleSetOrderHotelsBy}
        handleClearFilterAplicated={handleClearFilterAplicated}
      />
      <Grid container sx={{ px: 3, alignItems: 'center' }}>
        <HotelSearchHeader
          nameFilter={nameFilter}
          setNameFilter={setNameFilter}
          quantityFiltered={quantityFiltered}
          citySelected={citySelected}
          handleClickOpen={handleClickOpen}
          allFilteredHotels={allFilteredHotels}
          isLoadingResults={isLoadingResults}
          showProgress={showProgress}
          setShowProgress={setShowProgress}
        />
      </Grid>
      <HotelsResultsContainer
        isMobile={isMobile}
        viewFullWidhtMap={viewFullWidhtMap}
        hotelsWithPagination={hotelsWithPagination}
        handleCardMouseEnter={handleCardMouseEnter}
        handleCardMouseLeave={handleCardMouseLeave}
        tokenMap={tokenMap}
        total_passengers={tp}
        totalNights={tn}
        getFavConfig={getFavConfig}
        hotelSearchResults={hotelSearchResults}
        sites={sites}
        pageQuantity={pageQuantity}
        actualPage={actualPage}
        setActualPage={setActualPage}
        aboutSection={aboutSection}
        mapCenter={mapCenter}
        handleCloseModal={handleCloseModal}
        hoveredHotel={hoveredHotel}
        id_site={id_site}
        business_types={business_types}
        setIsLoadImage={setIsLoadImage}
        handleModal={handleModal}
        handleMapFullWidth={handleMapFullWidth}
        showModal={showModal}
        handleChangePage={handleChangePage}
        hotel={hotel}
        isLoadImage={isLoadImage}
        allFilteredHotels={allFilteredHotels}
        isLoadingResults={isLoadingResults}
        hotReferenceCities={hotReferenceCities}
        searchInfo={searchInfo}
        showProgress={showProgress}
      />
    </Grid>
  );
};

export default HotelSearchResults;
